import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { apiPost } from '../services/apiService';
import SEO from '../components/SEO';

const CHECKOUT_PLANS = [
  { key: 'basico', label: 'Básico', price: 'R$9,90', originalPrice: 'R$15,90', cases: '10 casos/mês', priceId: process.env.REACT_APP_PRICE_BASICO || '' },
  { key: 'pro',    label: 'Pro',    price: 'R$29,90', originalPrice: 'R$49,90', cases: '40 casos/mês', priceId: process.env.REACT_APP_PRICE_PRO    || '', popular: true },
  { key: 'intensivo', label: 'Intensivo', price: 'R$59,90', originalPrice: 'R$79,90', cases: '100 casos/mês', priceId: process.env.REACT_APP_PRICE_INTENSIVO || '' },
];

function getEmailFromToken(): string {
  try {
    const token = localStorage.getItem('auth0_access_token') || '';
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.email || '';
  } catch { return ''; }
}

export default function SubscribePage() {
  const { logout } = useAuth();
  const [checkingOut, setCheckingOut] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSelectPlan = async (plan: typeof CHECKOUT_PLANS[0]) => {
    setCheckingOut(plan.key);
    setError(null);
    try {
      const email = getEmailFromToken();
      const { url } = await apiPost<{ url: string }>('/checkout/create-session', {
        priceId: plan.priceId,
        planKey: plan.key,
        email,
      });
      window.location.href = url;
    } catch (err: any) {
      console.error('Checkout error:', err);
      setError('Não foi possível iniciar o checkout. Tente novamente.');
      setCheckingOut(null);
    }
  };

  return (
    <div className="App">
      <SEO
        title="Planos e Preços"
        description="Escolha o melhor plano para praticar diagnóstico médico com IA. A partir de R$9,90/mês."
        path="/subscribe"
      />
      <div className="inactive-sub-screen">
        <div className="upgrade-hero">
          <h1>Escolha seu Plano</h1>
          <p>Você não possui uma assinatura ativa. Escolha um plano para começar a praticar.</p>
        </div>
        {error && <div className="upgrade-error">{error}</div>}
        <div className="upgrade-payment-notice">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
            <line x1="1" y1="10" x2="23" y2="10" />
          </svg>
          Você será redirecionado para o checkout seguro do Stripe.
        </div>
        <div className="upgrade-plans">
          {CHECKOUT_PLANS.map(plan => (
            <div key={plan.key} className={`upgrade-plan-card ${plan.popular ? 'upgrade-plan-featured' : ''}`}>
              {plan.popular && <div className="upgrade-plan-badge">Mais Popular</div>}
              <div className="upgrade-plan-name">{plan.label}</div>
              <div className="upgrade-plan-price-row">
                <span className="upgrade-plan-original">{plan.originalPrice}</span>
                <span className="upgrade-plan-amount">{plan.price}</span>
                <span className="upgrade-plan-period">/mês</span>
              </div>
              <div className="upgrade-plan-cases">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                {plan.cases}
              </div>
              <button
                className={`upgrade-plan-btn ${plan.popular ? 'upgrade-plan-btn-primary' : 'upgrade-plan-btn-outline'}`}
                disabled={checkingOut !== null}
                onClick={() => handleSelectPlan(plan)}
              >
                {checkingOut === plan.key ? 'Redirecionando...' : 'Assinar'}
              </button>
            </div>
          ))}
        </div>
        <button className="upgrade-back-btn" onClick={logout} style={{ marginTop: '1rem', alignSelf: 'center' }}>
          Sair da conta
        </button>
      </div>
    </div>
  );
}
